module.exports = __webpack_public_path__ + "static/media/Event_Breakdown_2.073838b8.png";